import React from 'react';
import { observer } from 'mobx-react-lite';
import { colors, IMFormModal, IMSubmitButton } from '@insurancemenu/imenu-components-lib';

import { Add, Delete, InfoButton, Mail } from '@insurancemenu/imenu-components-lib/dist/icons';
import { SendOutEmailsModalStore } from 'store/general/sendOutEmailsModalStore';
import {
  CcFieldWrapperStyled,
  ListTitleStyled,
  ButtonStyled,
  CcFieldsListStyled,
  FormContentStyled,
  PrimaryEmailSectionStyled,
  IMInputTextStyled,
  IMTextAreaStyled,
  CcSectionWrapperStyled,
  ErrorStyled,
} from './styles';
import {
  ADD_CC_BTN_TEST_ID,
  DELETE_CC_BUTTON_TEST_ID,
  EMAILS_UNIQUENESS_ERROR_TEST_ID,
  SEND_OUT_EMAILS_MODAL_TEST_ID,
} from '../constants';

interface Props {
  title: string;
  subtitle: string;
  modalStore: SendOutEmailsModalStore;
  formId: string;
  withMessage?: boolean;
}

const SendOutEmailsModal: React.FC<Props> = observer(({ title, subtitle, formId, modalStore, withMessage = false }) => {
  const { form, ccFields, isVisible, clearModalData, addCc, close, areAllEmailsUnique } = modalStore;

  const onCloseAfterMessageIsSent = (): void => {
    clearModalData();
    close();
  };

  return (
    <IMFormModal
      show={isVisible}
      title={title}
      subtitle={subtitle}
      formController={form}
      formId={formId}
      formContent={
        <FormContentStyled>
          <ListTitleStyled>Primary Email</ListTitleStyled>
          <PrimaryEmailSectionStyled>
            <IMInputTextStyled placeholder="Primary email" name="primaryEmail" />
            <ButtonStyled
              type="text"
              color="primary"
              size="small"
              leftIconProp={<Add />}
              onClick={addCc}
              data-test-id={ADD_CC_BTN_TEST_ID}
            >
              Add CC
            </ButtonStyled>
          </PrimaryEmailSectionStyled>
          {ccFields.length > 0 && (
            <CcSectionWrapperStyled>
              <ListTitleStyled>CC emails:</ListTitleStyled>
              <CcFieldsListStyled>
                {ccFields.map((fieldId) => (
                  <CcFieldWrapperStyled key={fieldId}>
                    <IMInputTextStyled name={fieldId} width="30rem" />
                    <ButtonStyled
                      type="text"
                      color="custom"
                      size="small"
                      customColor={colors.red[600]}
                      onClick={() => form.removeFormField(fieldId)}
                      leftIconProp={<Delete />}
                      data-test-id={DELETE_CC_BUTTON_TEST_ID}
                    >
                      Remove
                    </ButtonStyled>
                  </CcFieldWrapperStyled>
                ))}
              </CcFieldsListStyled>
            </CcSectionWrapperStyled>
          )}
          {withMessage && <IMTextAreaStyled label="Email message" name="message" />}
          {!areAllEmailsUnique && (
            <ErrorStyled data-test-id={EMAILS_UNIQUENESS_ERROR_TEST_ID}>
              <InfoButton width="2rem" height="2rem" color={colors.red[600]} />
              <span>Emails must be unique. Please remove duplicates before saving.</span>
            </ErrorStyled>
          )}
        </FormContentStyled>
      }
      submitButton={
        <IMSubmitButton disabled={!form.basicFieldsValidationsPassed || !areAllEmailsUnique}>Send</IMSubmitButton>
      }
      submitButtonText="Send"
      showCloseButton={false}
      onClose={onCloseAfterMessageIsSent}
      icon={<Mail width="5.6rem" color={colors.green[600]} />}
      data-test-id={SEND_OUT_EMAILS_MODAL_TEST_ID}
    />
  );
});

export default SendOutEmailsModal;
